import React from 'react'

import "./core-landing-page.css"

const CoreLandingPage = (props: CoreLandingPageConfig) => {

	return (
		<div className="core-landing-page" style={{
		}}>
			<iframe className='core-landing-page-frame' src='./assets/core/landing-page/index.html'></iframe>
		</div>
	);

};

export interface CoreLandingPageConfig {

}

export default CoreLandingPage;